import { render, staticRenderFns } from "./manageParcel_kdy.vue?vue&type=template&id=7b52d4e1&scoped=true&"
import script from "./manageParcel_kdy.vue?vue&type=script&lang=js&"
export * from "./manageParcel_kdy.vue?vue&type=script&lang=js&"
import style0 from "./manageParcel_kdy.vue?vue&type=style&index=0&id=7b52d4e1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b52d4e1",
  null
  
)

export default component.exports